interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  onClick?: () => void;
  type: "submit" | "reset" | "button" | undefined;
  disabled?: boolean;
}

const RegisterButton = (props: ButtonProps) => {
  const { label, onClick, type, disabled, ...rest } = props;
  return (
    <button
      type={type}
      disabled={disabled}
      className={`w-full text-white ${
        disabled && "bg-gray-500 pointer-events-none"
      } bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-sm shadow-lg text-md px-5 py-2.5 text-center`}
      onClick={onClick}
      {...rest}
    >
      {label}
    </button>
  );
};

export default RegisterButton;
